import http, { HttpSuccessOrErrorType } from '../http';
import { Condition } from '../../models/abstract/condition.entity';
import { AxiosRequestConfig } from 'axios';
import { SensitiveRecord } from '../../models/sensitive-record.entity';

export default {

    /**
     * 查找所有敏感操作记录。
     * @param params 参数
     */
    async get_sensitive_operation_record(params: SensitiveRecord & Condition, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<{
            dbResults: SensitiveRecord[],
            totalCount: Array<{
                count: number;
            }>
        }[]>> {
        return await http.get(`/critical_operations`, {
            params: {
                ...params
            },
            ...config
        })
    },

}